'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _component = require('@loadable/component');

var _component2 = _interopRequireDefault(_component);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseComponent2 = require('../base/BaseComponent');

var _BaseComponent3 = _interopRequireDefault(_BaseComponent2);

var _ConfigGlobal = require('../config/ConfigGlobal');

var _ConfigGlobal2 = _interopRequireDefault(_ConfigGlobal);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cleave = (0, _component2.default)(function () {
  return import("../lib/cleave/cleave-react-node");
});
var Avatar = (0, _component2.default)(function () {
  return import("antd/lib/avatar");
});
var Select = (0, _component2.default)(function () {
  return import("antd/lib/select");
});

var Option = Select.Option;

var IDTextbox = function (_BaseComponent) {
  (0, _inherits3.default)(IDTextbox, _BaseComponent);

  function IDTextbox(props) {
    (0, _classCallCheck3.default)(this, IDTextbox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IDTextbox.__proto__ || (0, _getPrototypeOf2.default)(IDTextbox)).call(this, props));

    _initialiseProps.call(_this);

    var _this$convertValue = _this.convertValue(!_this.checkIsEmptyOrNull(props.value) ? props.value : props.defaultValue),
        value = _this$convertValue.value,
        countryCode = _this$convertValue.countryCode;

    _this.state = {
      isFocus: false,
      value: value,
      min: props.min,
      max: props.max,
      countryCode: countryCode || props.countryCode
    };
    _this.updateValue = props.min !== undefined ? _lodash2.default.debounce(_this._updateValue, 500) : _this._updateValue;
    _this.classNameDefault = "textbox";
    _this.dataTestID = 'textbox';
    _this.inputType = "text";
    return _this;
  }

  (0, _createClass3.default)(IDTextbox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!_lodash2.default.has(nextProps, 'value')) {
        return;
      }
      var diffMin = false;
      var diffMax = false;
      var diffCountryCode = false;
      var diffVal = false;
      var _props = this.props,
          min = _props.min,
          max = _props.max;


      if (min != nextProps.min) {
        diffMin = true;
      }

      if (max != nextProps.max) {
        diffMax = true;
      }

      if (this.props.countryCode != nextProps.countryCode) {
        diffCountryCode = true;
      }

      if (this.compareValue(nextProps.value)) {
        diffVal = true;
      }

      if (diffMin || diffMax || diffCountryCode || diffVal) {
        if (diffVal) {
          this.tooglePlaceholder(nextProps.value);

          var _convertValue = this.convertValue(nextProps.value),
              value = _convertValue.value,
              countryCode = _convertValue.countryCode;

          var newValue = value;
        }
        this.setState({
          value: diffVal ? newValue : this.state.value,
          min: diffMin ? nextProps.min : this.state.min,
          max: diffMax ? nextProps.max : this.state.max,
          countryCode: diffVal && countryCode ? countryCode : diffCountryCode ? nextProps.countryCode : this.state.countryCode
        });
      }
    }
  }, {
    key: 'convertValue',
    value: function convertValue(value) {
      var _props2 = this.props,
          type = _props2.type,
          withCountryCode = _props2.withCountryCode,
          defaultCountryCode = _props2.defaultCountryCode;

      if (type === 'moneyVN') {
        var stringValue = '';
        if (!this.checkIsEmptyOrNull(value)) {
          stringValue = value.toString().replace(/\./g, ',');
        }
        return { value: stringValue };
      }
      if (type === 'phone' && withCountryCode) {
        if (!this.checkIsEmptyOrNull(value)) {
          var valueOptions = this.getCountryCode(value);
        }
        return {
          value: _lodash2.default.get(valueOptions, 'withoutCountryCode', value),
          countryCode: _lodash2.default.get(valueOptions, 'countryCode', defaultCountryCode)
        };
      }

      return { value: value };
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      var _this2 = this;

      var upperCase = this.props.upperCase;

      var newValue = value;
      if (upperCase && value) {
        newValue = value.toUpperCase();
      }

      this.tooglePlaceholder(value);
      if (this.props.type != "moneyVN") {
        this.setState({ value: value }, function () {
          _this2.props.onChange && _this2.props.onChange(newValue);
        });
      } else {
        this.props.onChange && this.props.onChange(newValue);
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      var value = this.state.value;
      var upperCase = this.props.upperCase;

      if (upperCase && value) {
        return value.toUpperCase();
      }
      return value;
    }
  }, {
    key: 'onFocus',
    value: function onFocus() {
      if (this.Cleave) {
        this.Cleave.element && this.Cleave.element.focus();
      }
      if (this.input) {
        this.input.focus();
      }
    }
  }, {
    key: 'setMax',
    value: function setMax(max) {
      this.setState({
        max: max
      });
    }
  }, {
    key: 'setMin',
    value: function setMin(min) {
      this.setState({
        min: min
      });
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var options = {};
      var _props3 = this.props,
          type = _props3.type,
          prefix = _props3.prefix,
          decimalScale = _props3.decimalScale,
          positiveOnly = _props3.positiveOnly;


      switch (type) {
        case 'number':
          options = {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand'
          };
          break;
        case 'money':
          options = {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
            prefix: prefix,
            rawValueTrimPrefix: true
          };
          break;
        case 'moneyVN':
          options = {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
            prefix: prefix,
            rawValueTrimPrefix: true,
            numeralDecimalMark: ',',
            delimiter: '.',
            numeralDecimalScale: decimalScale,
            numeralPositiveOnly: positiveOnly
          };
          break;
        case 'credit':
          options = {
            creditCard: true,
            delimiter: '-'
          };
          break;
        case 'phone':
          // if (this.props.withCountryCode) {
          //   options = {
          //     numeral: true,
          //     numeralDecimalMark: '',
          //     delimiter: '',
          //     blocks: [4, 3, 3],
          //     delimiters: [' ', ' ', ' ']
          //   };
          // } else {
          options = {
            numericOnly: true,
            blocks: [4, 3, 3],
            delimiters: [' ', ' ', ' ']
          };
          // }
          break;
        default:
          break;
      }
      return (0, _assign2.default)(options, this.props.options);
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this3 = this;

      // if (!this.props.fromIDInput) {
      //   throw new Error(`Vui lòng sử dụng <IDInput type="${this.inputType}" />`);
      // }
      var _props4 = this.props,
          disabled = _props4.disabled,
          type = _props4.type,
          readOnly = _props4.readOnly,
          autoComplete = _props4.autoComplete,
          autoFocus = _props4.autoFocus,
          name = _props4.name,
          inputCls = _props4.inputCls,
          textAlignInput = _props4.textAlignInput,
          inputStyle = _props4.inputStyle,
          onKeyPress = _props4.onKeyPress,
          _onKeyDown = _props4.onKeyDown,
          inputMode = _props4.inputMode,
          withCountryCode = _props4.withCountryCode,
          defaultCountryCode = _props4.defaultCountryCode,
          countryCodeOptions = _props4.countryCodeOptions,
          countryCodeLabelKey = _props4.countryCodeLabelKey,
          countryCodeWidth = _props4.countryCodeWidth,
          countryCodeDisabledFLag = _props4.countryCodeDisabledFLag;
      var _state = this.state,
          value = _state.value,
          countryCode = _state.countryCode;

      if (type && type !== "text") {
        if (type === 'phone' && withCountryCode) {
          return _react2.default.createElement(
            'div',
            { className: 'phone-input' },
            _react2.default.createElement(
              Select,
              {
                showSearch: true,
                className: 'dial-code-select ' + (countryCodeDisabledFLag && 'dial-code-select-no-flag'),
                showArrow: false,
                suffixIcon: _react2.default.createElement('div', null),
                onChange: this.handleCountryCodeChange,
                defaultValue: defaultCountryCode,
                value: countryCode,
                style: { width: countryCodeWidth },
                filterOption: function filterOption(input, option) {
                  return _lodash2.default.get(option, 'children.props.children[1].props.children', '').toLowerCase().indexOf(input.toLowerCase()) >= 0 || _lodash2.default.get(option, 'value', '').toLowerCase().indexOf(input.toLowerCase()) >= 0;
                }
              },
              _lodash2.default.map(countryCodeOptions, function (item, index) {
                return _react2.default.createElement(
                  Option,
                  { key: '' + index, value: item.value, className: 'country-code-items' },
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', alignItems: 'center' } },
                    countryCodeDisabledFLag ? null : _react2.default.createElement(
                      'div',
                      { style: { width: '30px', height: '20px', display: 'flex' } },
                      _react2.default.createElement(Avatar, {
                        shape: 'square',
                        style: { width: '100%', height: '100%' },
                        src: item.flag
                      })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'country-code', style: { paddingLeft: '5px', fontSize: '12px', flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } },
                      _lodash2.default.get(item, countryCodeLabelKey) || item.value
                    )
                  )
                );
              })
            ),
            _react2.default.createElement('div', { className: 'indicator-separator' }),
            _react2.default.createElement(Cleave, {
              className: (0, _classnames2.default)('text-input', inputCls),
              ref: function ref(c) {
                _this3.Cleave = c;
              },
              htmlRef: function htmlRef(c) {
                _this3.ccInput = c;
              },
              placeholder: '',
              onChange: this.handleChange,
              onFocus: this.handleFocus,
              onBlur: this.handleBlur,
              onKeyPress: onKeyPress,
              onKeyDown: function onKeyDown(e) {
                _this3.onKeyDown(e);
                _onKeyDown && _onKeyDown(e);
              },
              disabled: disabled,
              value: value,
              name: name,
              options: this.getOptions(),
              onInit: this.onInit,
              style: (0, _assign2.default)({}, {
                flex: 1,
                border: 0,
                padding: 10,
                height: '100%',
                outline: 0,
                background: 'transparent',
                textAlign: textAlignInput
              }, inputStyle),
              readOnly: readOnly,
              autoComplete: autoComplete,
              inputMode: inputMode
            })
          );
        }
        return _react2.default.createElement(Cleave, {
          className: (0, _classnames2.default)('text-input', inputCls),
          ref: function ref(c) {
            _this3.Cleave = c;
          },
          htmlRef: function htmlRef(c) {
            _this3.ccInput = c;
          },
          placeholder: '',
          onChange: this.handleChange,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onKeyPress: onKeyPress,
          onKeyDown: function onKeyDown(e) {
            _this3.onKeyDown(e);
            _onKeyDown && _onKeyDown(e);
          },
          disabled: disabled,
          value: value,
          name: name,
          options: this.getOptions(),
          onInit: this.onInit,
          style: (0, _assign2.default)({}, {
            flex: 1,
            border: 0,
            padding: 10,
            height: '100%',
            outline: 0,
            background: 'transparent',
            textAlign: textAlignInput
          }, inputStyle),
          readOnly: readOnly,
          autoComplete: autoComplete,
          inputMode: inputMode
        });
      }
      return _react2.default.createElement('input', {
        onKeyPress: onKeyPress,
        onKeyDown: _onKeyDown,
        className: (0, _classnames2.default)('text-input', inputCls),
        ref: function ref(c) {
          _this3.input = c;
        },
        placeholder: '',
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        disabled: disabled,
        value: value,
        name: name,
        options: this.getOptions(),
        style: (0, _assign2.default)({ textTransform: this.props.upperCase ? "uppercase" : "" }, {
          flex: 1,
          border: 0,
          padding: 10,
          height: '100%',
          outline: 0,
          background: 'transparent',
          textAlign: textAlignInput
        }, inputStyle),
        readOnly: readOnly,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        inputMode: inputMode
      });
    }
  }]);
  return IDTextbox;
}(_BaseComponent3.default);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onInit = function (cleave) {
    _this4.setState({ rawCleave: cleave });
  };

  this.handleChange = function (event) {
    var _props5 = _this4.props,
        disabled = _props5.disabled,
        readOnly = _props5.readOnly;

    if (disabled || readOnly) {
      return;
    }
    var type = _this4.props.type;
    var _state2 = _this4.state,
        min = _state2.min,
        max = _state2.max;

    var value = type && type !== "text" ? event.target.rawValue : event.target.value;
    var newValue = value;
    _this4.tooglePlaceholder(value);

    if (min !== undefined && parseFloat(newValue) < parseFloat(min)) {
      newValue = min;
    }

    if (max !== undefined && parseFloat(newValue) > parseFloat(max)) {
      newValue = max;
    }

    _this4.updateValue(newValue, value);
  };

  this.handleCountryCodeChange = function (value) {
    _this4.setState({ countryCode: value });
  };

  this._updateValue = function (newValue, curValue) {
    if (newValue !== _this4.state.value) {
      _this4.setValue(newValue);
    }
    if (newValue !== curValue) {
      _this4.state.rawCleave && _this4.state.rawCleave.setRawValue(newValue);
    }
  };

  this.handleFocus = function (event) {
    _this4.Placeholder && _this4.Placeholder.hidden();
    _this4.props.onFocus && _this4.props.onFocus(event);
  };

  this.handleBlur = function (event) {
    var type = _this4.props.type;

    var value = type && type !== "text" ? event.target.rawValue : event.target.value;
    _this4.tooglePlaceholder(value);
    _this4.props.onBlur && _this4.props.onBlur(value);
  };

  this.onClear = function () {
    _this4.setValue('');
    _this4.onFocus();
  };

  this.onKeyDown = function () {};
};

exports.default = IDTextbox;


IDTextbox.defaultProps = {
  iconCls: '',
  iconType: _lodash2.default.get(_ConfigGlobal2.default, 'iconType.edit', 'edit'),
  isClearable: true,
  visibleIcon: true,
  disabled: false,
  iconAlign: 'after',
  placeholder: 'Input...',
  type: 'text',
  textAlign: 'left',
  countryCodeOptions: [],
  countryCodeLabelKey: 'label',
  countryCodeWidth: 100
};

IDTextbox.propTypes = {
  iconCls: _propTypes2.default.string,
  iconAlign: _propTypes2.default.string,
  isClearable: _propTypes2.default.bool,
  visibleIcon: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool
};